import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const DbnpRegistriesPanInfoComponent = ({ handleInnerFormChange, selectedDbnpRegistry }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                    isDisabled

                        label="Name As Per Pan"
                        name="name_as_per_pan"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigPan.name_as_per_pan',
                                selectedDbnpRegistry?.RegConfigPan
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.RegConfigPan?.name_as_per_pan}
                    />
                    <InputContainer
                    isDisabled

                        label="Pan No"
                        name="pan_no"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigPan.pan_no',
                                selectedDbnpRegistry?.RegConfigPan
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.RegConfigPan?.pan_no}
                    />
                    <InputContainer
                    isDisabled

                        label="Date Of Incorporation"
                        name="date_of_incorporation"
                        onValueChange={(event: any) => {
                            handleInnerFormChange(
                                event.target.value,
                                'RegConfigPan.date_of_incorporation',
                                selectedDbnpRegistry?.RegConfigPan
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.RegConfigPan?.date_of_incorporation}
                    />
                </div>
            }
            expandedPanel="pan info"
            headerTitle="PAN Info"
        />
    </>
)

export default DbnpRegistriesPanInfoComponent;